import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

// انیمیشن ورود هنگام اسکرول — سبک و بدون کتابخانه‌ی خارجی (فقط IntersectionObserver)
// تا فشار اضافه‌ای به حجم بیلد و رم سرور وارد نکند. prefers-reduced-motion رعایت می‌شود.
export function Reveal({ children, delay = 0, y = 24, sx, ...boxProps }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) { setVisible(true); return; }
        const node = ref.current;
        if (!node) return;
        const obs = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
            { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );
        obs.observe(node);
        return () => obs.disconnect();
    }, []);

    return (
        <Box
            ref={ref}
            {...boxProps}
            sx={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : `translateY(${y}px)`,
                transition: `opacity .7s ease ${delay}s, transform .7s cubic-bezier(.16,1,.3,1) ${delay}s`,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}

// یک بلاب گرادیانت تزئینی قابل استفاده‌ی مجدد برای پس‌زمینه‌ی بخش‌ها
export function DecorBlob({ color, size = 320, top, bottom, insetInlineStart, insetInlineEnd, opacity = 1 }) {
    return (
        <Box sx={{
            position: 'absolute', width: size, height: size, borderRadius: '50%', pointerEvents: 'none',
            background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
            top, bottom, insetInlineStart, insetInlineEnd, opacity,
        }} />
    );
}

export default Reveal;
